<template>
  <section class="listing">
    <div class="header">
      <div class="title">Clientes</div>
    </div>

    <form @submit.prevent="getData" class="form form-search">
      <input v-model="iniDate" @change="getData" type="date" />
      <input v-model="endDate" @change="getData" type="date" />
      <input v-model="search" type="text" placeholder="Assinante..." />
      <div>
        <button type="submit" class="btn-search">
          <i class="fas fa-search"></i>
        </button>
      </div>
    </form>

    <transition name="show" mode="out-in">
      <i v-if="loading" class="fas fa-spinner loading-big"></i>
      <div v-if="!loading" style="margin-top: 10px">
        <div class="sum-group">
          <div class="sum">
            <span>Clientes</span>
            <span>{{ customers.length.toLocaleString('pt-br') }}</span>
          </div>
          <div class="sum">
            <span>Valor Total</span>
            <span>{{ total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</span>
          </div>
        </div>
        <div class="list-cards">
          <div v-for="(c, i) in customers" :key="i" class="list">
            <div v-if="i > 0 ? getDay(c.date) !== getDay(customers[i - 1].date) : true" class="calendar">
              <span>{{ getDay(c.date) }}</span>
              <span>{{ getMonthText(c.date) }}</span>
            </div>
            <div v-else class="calendar-spacer"></div>
            <div class="data">
              <div class="main-data">{{ c.name }}</div>
              <div class="detail-data">{{ c.login }}</div>
            </div>
            <div class="list-meta">
              <div class="main-data">{{ (c.amount || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</div>
            </div>
            <div class="actions">
              <button @click="$router.push(`/customer/${c.id}`)" class="button-action"><i class="fas fa-eye"></i><span>VISUALIZAR</span></button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <Customer v-if="customer" :id="customer" :customerData="customerData" />
  </section>
</template>

<script>
import logger from '../../logger'
import { getAll } from '../api/customer'
import Customer from './Customer.vue'

export default {
  name: 'customers',
  components: { Customer },
  props: ['id'],
  data () {
    return {
      loading: true,
      customers: [],
      customer: null,
      customerData: null,
      iniDate: null,
      endDate: null,
      fonte: null,
      search: ''
    }
  },
  watch: {
    async '$route' (value) {
      this.customer = value.params['id'] || null
      if (!value.params['id']) {
        this.getData()
      } else {
        this.customerData = this.customers.find(x => x.id === Number(value.params['id']))
      }
    }
  },
  computed: {
    total () {
      return this.customers.map(x => Number(x.amount)).reduce((acc, cur) => acc + cur, 0)
    },
    filtered () {
      return this.customers.filter(x => Object.keys(x).some(key => String(x[key]).toUpperCase().includes(this.search.toUpperCase())))
    }
  },
  async mounted () {
    try {
      const dateIni = new Date()
      const dateFim = new Date()
      dateFim.setMonth(dateFim.getMonth() + 1)
      dateFim.setDate(1)
      dateFim.setDate(dateFim.getDate() - 1)
      this.endDate = dateFim.toISOString().split('T')[0]

      dateIni.setDate(1)
      this.iniDate = dateIni.toISOString().split('T')[0]
      this.getData()
    } catch (error) {
      logger.error(error)
    }
  },
  methods: {
    async getData () {
      this.loading = true
      try {
        const customers = await getAll(this.iniDate, this.endDate)
        if (this.search) {
          this.customers = customers.filter(x => String(x.name).toUpperCase().includes(this.search.toUpperCase()))
        } else {
          this.customers = customers || []
        }
      } catch (error) {
        logger.error(error)
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";
</style>
